<template>
  <div><el-row v-for="(file,i) in filelist" :key="i" :class="itemclass">
    <slot :file="file" :index="i">
    </slot>
  </el-row></div>
</template>
<script>
  import Vue from "vue";
  import $ from "jquery";
  export default {
    name: 'MyListUpload',
    model: {
      prop: 'inputval',
    },
    props: {
      autoremove: {
        type: [Boolean],
        default(){
          return true;
        }
      },
      filelist: {
        type: [Array],
        default(){
          return [];
        }
      },
      uploadlist: {
        type: [Array],
        default(){
          return [];
        }
      },
    },
    computed: {},
    data(){
      return $.extend(true, {}, this.getDefData(), {}, this.getFromParent())
    },
    watch: {
      inputval(a, b, c){
        var parent = this.getFromParent();
        //用extend时不能带true，否则会出现无法重新渲染的问题原因未知
        $.extend(this, parent);
      }
    },
    methods: {
      toSelectFiles(directupload,more, filterfn){
        var input = '<input type="file" {1}'.format(more ? 'multiple' : '');
        $(input).change((ev) => {
          var files = ev.currentTarget.files;
          if ($.isFunction(filterfn)) {
            files = filterfn(files);
          }
          if(files==false){
              return;
          }
          for (var i = 0; i < files.length; i++) {
            var file = files[i];
            var add = true;
            var info = {};
            for (var key in file) {
              info[key] = file[key];
            }
            info._uploading=true;
            this.filelist.push(info);
            this.uploadlist.push(file);
          }
        }).click();
      },
      toUpload(){
        for (var i = 0; i < this.uploadlist.length; i++) {
          var file = this.uploadlist[i];

        }
      },
      upload(file, index){
        var that = this;
        var formData = new FormData();
        formData.append("pdf", file);
        $.ajax({
          url: hUrl + 'admin/coa/upload-coa',
          type: "POST",
          data: formData,
          xhr: function () { //获取ajaxSettings中的xhr对象，为它的upload属性绑定progress事件的处理函数
            var myXhr = $.ajaxSettings.xhr();
            if (myXhr.upload) { //检查upload属性是否存在
              //绑定progress事件的回调函数
              if (myXhr.upload.addEventListener) {                    //所有主流浏览器，除了 IE 8 及更早 IE版本
                myXhr.upload.addEventListener('progress',
                  function (e) {
                    that.progressHandlingFunction(e, index);
                  }, false);
              } else if (myXhr.upload.attachEvent) {                  // IE 8 及更早 IE 版本
                myXhr.upload.attachEvent('progress', function (e) {
                  that.progressHandlingFunction(e, index);
                }, false);
              }
              that.resetProgress(index);
            }
            return myXhr; //xhr对象返回给jQuery使用
          },
          success: function (result) {
            that.uploadStatus[index].status = result.status;
            that.uploadStatus[index].uploading=false;
            var tag=true;
            for (var i = 0; i < that.uploadStatus.length; i++) {
              var obj = that.uploadStatus[i];
              tag=tag&&!obj.uploading;
            }
            that.loading=!tag;
          },
//                async: true,//必须为true，才会有进度，此时会有个两个请求，一个上传一个取进度，默认是true
          contentType: false, //必须false才会自动加上正确的Content-Type
          processData: false  //必须false才会避开jQuery对 formdata 的默认处理
        });
      },
      getFromParent(){
        var data = {};
        data.filelist = this.inputval || [];
        return data;
      }
    }

  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/MyListUpload.vue